
let imgBtns = document.querySelectorAll(".gallery-swap-image__btn");


/*
 * Desktop = hover
 * Mobile = click
 *
 * Both listeners are added once.
 * The viewport check determines which one should run.
 */
imgBtns.forEach(function (btn) {

    btn.addEventListener("mouseenter", function () {

        if (window.innerWidth > 768) {
            swapImg(btn);
        }

    });


    btn.addEventListener("click", function () {

        if (window.innerWidth <= 768) {
            swapImg(btn);
        }

    });

});


function getThumbImgSrc(b) {

    let img = b.querySelector("img");

    if (!img) {
        return null;
    }

    return getFileWithoutWidth(img.src);
}


function getFileWithoutWidth(src) {

    if (!src) {
        return "";
    }

    let string = "width=";
    let index = src.indexOf(string);

    if (index === -1) {
        return src;
    }

    return src.substr(0, index + string.length);
}


function setActiveStep(btn) {

    let galleryList = btn.closest(".gallery-step-list");

    /*
     * Only apply active-state behavior when
     * the section opacity setting is enabled.
     */
    if (
        !galleryList ||
        !galleryList.classList.contains("gallery-step-list--opacity")
    ) {
        return;
    }


    /*
     * Remove active state from every step
     * within THIS gallery only.
     */
    let galleryItems = galleryList.querySelectorAll(".gallery-step-item");

    galleryItems.forEach(function (item) {
        item.classList.remove("is-active");
    });


    /*
     * Make the current step active.
     */
    let currentItem = btn.closest(".gallery-step-item");

    if (currentItem) {
        currentItem.classList.add("is-active");
    }
}


function swapImg(b) {

    let thumbImgSrc = getThumbImgSrc(b);

    /*
     * If this step doesn't contain an image,
     * don't attempt an image swap.
     */
    if (!thumbImgSrc) {
        return;
    }


    let parent = b.closest(".kdo-click-hover-gallery__grid");

    if (!parent) {
        return;
    }


    let swapImg = parent.querySelector(".swapping-image");

    /*
     * Single-image / text-only layouts won't
     * necessarily contain a swapping image.
     */
    if (!swapImg) {
        return;
    }


    let oldImgSrc = swapImg.src;

    let oldImgSize = "";

    if (oldImgSrc.includes("width=")) {
        oldImgSize = oldImgSrc.split("width=")[1];
    }


    let newSrc = thumbImgSrc + oldImgSize;

    swapImg.src = newSrc;

    /*
     * Clear Shopify's srcset so it doesn't
     * override the newly selected src.
     */
    swapImg.srcset = "";


    /*
     * Update thumbnail opacity / active state.
     */
    setActiveStep(b);
}